import { createFileRoute, Link } from '@tanstack/react-router';

import { Button } from '~/components/ui/Button.js';
import { Spinner } from '~/components/ui/Spinner.js';
import { ArticleForm } from '~/features/articles/ArticleForm.js';
import { useCategoriesList } from '~/features/taxonomies/hooks.js';

export const Route = createFileRoute('/_auth/articles/new')({
  component: ArticleNewPage,
});

function ArticleNewPage() {
  const { data: categories, isLoading, error } = useCategoriesList();

  return (
    <div className="page">
      <header className="page-head">
        <p className="eyebrow">/ Publicações</p>
        <h1 className="page-title">Novo artigo</h1>
        <p className="page-sub">
          Salve como rascunho quando quiser pausar a escrita. Publique quando o conteúdo estiver
          pronto — o tempo de leitura é calculado automaticamente a partir do corpo.
        </p>
      </header>

      {isLoading && (
        <div className="dt__state">
          <Spinner size="lg" />
        </div>
      )}

      {error && (
        <div className="dt__state">
          <p className="dt__state-title">Não foi possível carregar categorias.</p>
          <p className="dt__state-sub">{error.displayMessage}</p>
        </div>
      )}

      {categories && <ArticleForm categories={categories} />}

      <Link to="/articles">
        <Button variant="ghost">← Voltar à lista</Button>
      </Link>
    </div>
  );
}
